import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AuthAside } from "../components/AuthAside";
import { IS_MOCK } from "../api/client";
import "../styles/auth.css";

export function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    if (password.length < 8) {
      setErr("Password must be at least 8 characters.");
      return;
    }
    setBusy(true);
    try {
      await register(email, name, password);
      nav("/app");
    } catch (ex) {
      setErr((ex as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-wrap">
      <AuthAside />
      <main className="auth-main">
        <div className="auth-card">
          <h1>Start climbing.</h1>
          <p className="sub">Free forever for hobby projects. No card required.</p>

          <form className="auth-form" onSubmit={submit}>
            {err && <div className="auth-err">{err}</div>}
            <div className="field">
              <label htmlFor="name">Name</label>
              <input id="name" className="input" type="text" autoComplete="name"
                value={name} onChange={(e) => setName(e.target.value)} required />
            </div>
            <div className="field">
              <label htmlFor="email">Work email</label>
              <input id="email" className="input" type="email" autoComplete="email"
                value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="field">
              <label htmlFor="pw">Password</label>
              <input id="pw" className="input" type="password" autoComplete="new-password"
                value={password} onChange={(e) => setPassword(e.target.value)} required />
              <span className="hint">At least 8 characters. You'll verify your email before production keys.</span>
            </div>
            <button className="btn btn-primary" disabled={busy} style={{ justifyContent: "center" }}>
              {busy ? <span className="spinner" /> : "Create account →"}
            </button>
          </form>

          {IS_MOCK && (
            <div className="mock-note">
              mock mode — registration creates a local demo session; no email is sent.
            </div>
          )}

          <p className="auth-foot">
            Already have an account? <Link to="/login">Sign in</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
